<template lang="pug">
  v-layout
    v-dialog(v-if="nombreProducto !== 'PLANGARANTIZADO' && firstTime" v-model="openSuenioPopup" persistent width="380")
      v-card(style="border-radius:8px")
        v-card-text
          v-layout(column align-center)
            v-flex(style="height: 2em;")
              v-btn(@click="methodMyDream()" style="position: absolute;top: 5px;right: 5px;height: 2em;width: 2em;" color="#0855C4" fab  flat)
                v-icon(style="line-height: initial;") close
            v-flex.mt-1.mx-3
              p.mb-0(style="color:#454A6C;font-size:16px;line-height:1.15") Elige la meta que deseas alcanzar con el ahorro de tu seguro. Si no encuentras tu meta, elige&nbsp;
                b.omnesMedium Otra Meta
                |.
            v-flex.mx-3.mt-4.mb-5
              v-layout(column align-center)
                v-layout(row)
                  v-flex.xs6.mb-2
                    CardMisSolicitudes3(
                      :text="dreams[0].text"
                      :activo="true"
                      :icon="dreams[0].icon"
                      @cardMethod="methodMyDream"
                    )
                  v-flex.xs6.mb-2.ml-2
                    CardMisSolicitudes3(
                      :text="dreams[1].text"
                      :activo="true"
                      :icon="dreams[1].icon"
                      @cardMethod="methodMyDream"
                    )
                v-layout(row)
                  v-flex.xs6.mb-2
                    CardMisSolicitudes3(
                      :text="dreams[2].text"
                      :activo="true"
                      :icon="dreams[2].icon"
                      @cardMethod="methodMyDream"
                    )
                  v-flex.xs6.mb-2.ml-2
                    CardMisSolicitudes3(
                      :text="dreams[3].text"
                      :activo="true"
                      :icon="dreams[3].icon"
                      @cardMethod="methodMyDream"
                    )
                v-layout(row)
                  v-flex.xs6.mb-2
                    CardMisSolicitudes3(
                      :text="dreams[4].text"
                      :activo="true"
                      :icon="dreams[4].icon"
                      @cardMethod="methodMyDream"
                    )
                  v-flex.xs6.mb-2.ml-2
                    CardMisSolicitudes3(
                      :text="dreams[5].text"
                      :activo="true"
                      :icon="dreams[5].icon"
                      @cardMethod="methodMyDream"
                    )
            v-flex(mb-3)
              v-layout(row)
                v-flex(style="max-width: 17px !important;height: 17px;align-self: center;margin-right: 2px;")
                  img(:src="iconAlerta" style="height:15px")
                v-flex(style="line-height: 13px")
                  span(style="color: #919191; font-size:13px") Recuerda que una vez elegida la meta no podrá editar

    v-dialog(v-model="openPopupAux" fullscreen hide-overlay persistent transition='dialog-bottom-transition')
      v-card
        v-toolbar(dark color='primary')
          v-btn.btn-backspace(outline flat fab small @click="methodClosePopup")
            v-icon keyboard_backspace
          v-toolbar-title
            span(style="color: #ffffff; font-size: 20px;") Hoy
        v-card-text(style="padding: 1em 1.5em;")
          v-layout.box-hoy-desktop-formatter(column align-center)
            v-flex(v-if="nombreProducto !== 'PLANGARANTIZADO'" style="line-height:1.15")
              p.mb-2(style="color: #454A6C; font-size: 16px") Estás a poco de alcanzar tu meta para lo que  más anhelas y seguir protegiendo a tu familia.
              p.mb-0(style="color: #454A6C; font-size: 16px") Estos son tus aportes hasta el día de hoy.
            v-flex(v-else style="line-height:18px")
              span(style="color: #454A6C; font-size: 16px") Sigue alcanzando tus metas anuales de tu seguro&nbsp;
                b {{producto}}&nbsp;
                | y sigue protegiendo a los que más amas.
            v-flex(style="margin-top:1em")
              TarjetaDetalleMisMetas(
              :numeroMeta="''"
              :tipoMoneda="tipoMoneda"
              :totalPagoEfectuado="totalPagoEfectuado"
              :montoPorAcumular="montoAsegurado"
              :porcentajeAlcanzado="porcentajePolizaMethod"
              :mensajeMontoPorAcumular="'Iniciaste un '+inicioVigencia"
              :fechaInicial="inicioVigencia"
              :fechaFinal="finVigencia"
              :mensajeFinal="''"
              :anhoActual="'Total que deberás acumular en '+ periodoDePago + ' años'"
              :lock="false"
              :background="'#F1F1F1'"
              :idUnique="'meta-principal'"
              :meta = "meta"
              :mensajeTooltip="tipoMoneda + ' ' + totalPagoEfectuado"
              :fechaDescripcionHasta="fechaDescripcionHasta"
              :fechaDescripcionFaltan="fechaDescripcionFaltan"
                )
            v-flex(style="margin-top: 1.5em")
              v-layout(column align-center)
                v-flex(style="align-self: flex-start;")
                  span(style="color:#454A6C; font-size:18px")
                    b Metas anuales por completar
                v-flex(v-for="(item, index) in periodosPorCompletar" :key="item.key" style="margin:0.5em")
                  TarjetaDetalleMisMetas(
                  :numeroMeta="'Meta año '+(Number(item.anho))"
                  :tipoMoneda="tipoMoneda"
                  :montoPorAcumular="netoAnual"
                  :porcentajeAlcanzado="item.porcentaje"
                  :mensajeMontoPorAcumular="'Este es el monto anual que debes acumular'"
                  :fechaInicial="new Date((Number(fechaPeriodo[2])+Number(item.anho)-1),fechaPeriodo[1]-1,fechaPeriodo[0]).toLocaleDateString()"
                  :fechaFinal="new Date((Number(fechaPeriodo[2])+Number(item.anho)),fechaPeriodo[1],0).toLocaleDateString()"
                  :mensajeFinal="nombreProducto.includes('VIDACASH') ? '¡Sigue asegurando el futuro de los que más amas!' : ''"
                  :anhoActual="''"
                  :lock="item.lock"
                  :idUnique="'meta-hasta-5-'+item.anho+'-'+index"
                  :mensajeTooltip="item.pagoAlAnhoS"
                    )
            v-flex(style="margin-top: 1.5em")
              v-layout(column align-center)
                v-flex(style="align-self: flex-start;")
                  span(style="color:#454A6C; font-size:18px")
                    b Metas completadas ({{totalCompletados}})
                v-flex(v-for="(item, index) in periodosCompletados" :key="item.key" style="margin:0.5em")
                  TarjetaDetalleMisMetas(
                  :numeroMeta="'Meta año '+(Number(item.anho))"
                  :tipoMoneda="tipoMoneda"
                  :montoPorAcumular="netoAnual"
                  :porcentajeAlcanzado="1"
                  :mensajeMontoPorAcumular="' Este es el monto que acumulaste este año'"
                  :fechaInicial="new Date((Number(fechaPeriodo[2])+Number(item.anho)-1),fechaPeriodo[1]-1,fechaPeriodo[0]).toLocaleDateString()"
                  :fechaFinal="new Date((Number(fechaPeriodo[2])+Number(item.anho)),fechaPeriodo[1],0).toLocaleDateString()"
                  :mensajeFinal="`¡Lo lograste, este es un paso importante para asegurar tu ${nombreProducto.includes('VIDACASH') ? 'Vida con Devolución' : producto}!`"
                  :anhoActual="''"
                  :lock="item.lock"
                  :idUnique="'meta-hasta-5-'+item.anho+'-'+index"
                    )
        v-card-actions
          v-layout(column align-center)
            v-flex
              span(style="font-size: 18px;color: #0855C4;" @click="methodClosePopup")
                b Volver

</template>

<script>
import { mapActions } from 'vuex'
import CardMisSolicitudes3 from './CardMisSolicitudes3.vue'
import TarjetaDetalleMisMetas from './TarjetaDetalleMisMetas.vue'
import moment from 'moment'

export default {
  props: [
    'openPopup',
    'periodos',
    'tipoMoneda',
    'inicioVigencia',
    'finVigencia',
    'pagoHasta',
    'montoAsegurado',
    'periodoDePago',
    'cuota',
    'netoAnual',
    'totalPagoEfectuado',
    'cuotaPeriodo',
    'producto',
    'nombreProducto',
    'taggeo',
    'suenio'
  ],
  data () {
    return {
      iconAlerta: require('./../../assets/iconsv5/icon-alert.svg'),
      iconLogroAlcanzado: require('./../../assets/icons/icon-mensaje-meta-alcanzada.svg'),
      porcentajeAnual: '',
      periodosFormatter: null,
      fechaPeriodo: [],
      auxPagadoHasta: null,
      pagoAnual: 0,
      totalCompletados: 0,
      totalPorCompletar: 0,
      auxPeriodos: [],
      openSuenioPopup: false,
      firstTime: true,
      meta: null,
      fechaDescripcionFaltan: '',
      fechaDescripcionHasta: '',
      openPopupAux: false,
      dreamObj: {
        text: 'Otra Meta',
        icon: require('./../../assets/icons/icon-otra-meta.svg'),
        detail: 'Mi meta'
      },
      dreams: [
        {
          text: 'Viajar',
          icon: require('./../../assets/icons/icon-viaje.svg'),
          detail: 'Mi meta'
        },
        {
          text: 'Vivienda',
          icon: require('./../../assets/icons/icon-vivienda.svg'),
          detail: 'Mi meta'
        },
        {
          text: 'Estudios',
          icon: require('./../../assets/icons/icon-estudios.svg'),
          detail: 'Mi meta'
        },
        {
          text: 'Vehículo',
          icon: require('./../../assets/icons/icon-vehiculo.svg'),
          detail: 'Mi meta'
        },
        {
          text: 'Negocio',
          icon: require('./../../assets/icons/icon-negocio.svg'),
          detail: 'Mi meta'
        },
        {
          text: 'Otra Meta',
          icon: require('./../../assets/icons/icon-otra-meta.svg'),
          detail: 'Mi meta'
        }
      ]

    }
  },
  computed: {
    porcentajePeriodoMethod () {
      let totalPagos = (parseInt(this.totalPagoEfectuado) / Number(this.cuota))

      return totalPagos
    },

    periodosPorCompletar () {
      let self = this

      let firstElement = true
      let aux = this.auxPeriodos.filter((data, index) => {
        if (Number(data.anho) <= 5) {
          let auxPeriodo = self.inicioVigencia.split(/[/-]/)
          let auxInicioPeriodo = new Date(Number(auxPeriodo[2]) + Number(data.anho), Number(auxPeriodo[1]) - 1, Number(auxPeriodo[0]))
          if (auxInicioPeriodo > self.auxPagadoHasta) {
            let lock = auxInicioPeriodo > self.auxPagadoHasta

            data.lock = lock && firstElement
            firstElement = true

            // meta por completar
            if (!data.lock) {
              let fin = auxInicioPeriodo
              let inicio = new Date(Number(auxPeriodo[2]) + Number(data.anho) - 1, Number(auxPeriodo[1]) - 1, Number(auxPeriodo[0]))

              let auxPorcentaje = (self.auxPagadoHasta.getTime() - inicio.getTime()) / (fin.getTime() - inicio.getTime())
              data.porcentaje = auxPorcentaje
              let mesesPagado = self.mesesDiferencia(inicio, self.auxPagadoHasta)
              let pagoAlAnho = mesesPagado * parseFloat((self.cuota || '0').toString().replace(',', ''))

              data.pagoAlAnho = parseFloat(parseFloat(pagoAlAnho).toFixed(2)).toLocaleString('en-US')
              data.pagoAlAnhoS = self.tipoMoneda + data.pagoAlAnho
            } else if (index === 0) {
              data.lock = false
              let fin = auxInicioPeriodo
              let inicio = new Date(Number(auxPeriodo[2]) + Number(data.anho) - 1, Number(auxPeriodo[1]) - 1, Number(auxPeriodo[0]))

              let auxPorcentaje = (self.auxPagadoHasta.getTime() - inicio.getTime()) / (fin.getTime() - inicio.getTime())
              data.porcentaje = auxPorcentaje

              let mesesPagado = self.mesesDiferencia(inicio, self.auxPagadoHasta)
              let pagoAlAnho = mesesPagado * self.cuota

              data.pagoAlAnho = parseFloat(parseFloat(pagoAlAnho).toFixed(2)).toLocaleString('en-US')
              data.pagoAlAnhoS = self.tipoMoneda + data.pagoAlAnho
            }

            return data
          } else {
            firstElement = false
          }
        }
      })

      self.totalPorCompletar = aux.length
      return aux
    },
    periodosCompletados () {
      let self = this

      let aux = this.auxPeriodos.filter((data, index) => {
        if (Number(data.anho) <= 5) {
          let auxPeriodo = self.inicioVigencia.split(/[/-]/)
          let auxInicioPeriodo = new Date(Number(auxPeriodo[2]) + Number(data.anho), Number(auxPeriodo[1]) - 1, Number(auxPeriodo[0]))

          if (auxInicioPeriodo < self.auxPagadoHasta) {
            let lock = auxInicioPeriodo < self.auxPagadoHasta

            data.lock = !lock
            return data
          }
        }
      })

      self.totalCompletados = aux.length
      return aux
    },
    porcentajePolizaMethod () {
      let self = this

      // CALCULANDO  % TOTAL LA POLIZA
      let auxFin = self.finVigencia.split(/[/-]/)

      let auxInicio = self.inicioVigencia.split(/[/-]/)

      let finPoliza = new Date(Number(auxFin[2]), Number(auxFin[1]) - 1, Number(auxFin[0]))

      let inicioPoliza = new Date(Number(auxInicio[2]), Number(auxInicio[1]) - 1, Number(auxInicio[0]))

      let hasta = self.pagoHasta.split(/[/-]/)
      self.auxPagadoHasta = new Date(Number(hasta[2]), Number(hasta[1]) - 1, Number(hasta[0]))

      let porcentajePoliza = ((self.auxPagadoHasta.getTime() - inicioPoliza.getTime()) / (finPoliza.getTime() - inicioPoliza.getTime()))

      return porcentajePoliza
    }
  },
  mounted () {
    let self = this

    const metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Hoy 5', metadata})

    self.openPopupAux = self.openPopup
    // FORMATEANDO DATOS
    let fecha = new Date()
    let auxPeriodo = self.inicioVigencia.split(/[/-]/)
    self.numeroPeriodo = Number(fecha.getFullYear()) - Number(auxPeriodo[2])
    self.fechaPeriodo = auxPeriodo.map(data => Number(data))
    self.periodoActual = self.auxPeriodos.filter(dato => self.numeroPeriodo + 1 === Number(dato.anho))[0]
    self.pagoAnual = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(self.netoAnual)

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Hoy',
        'dispositivo': 'mobile'
      }
    })

    if (self.suenio && self.suenio !== undefined && self.suenio !== '') {
      self.meta = self.dreams.filter(dream => dream.text.toLowerCase() === self.suenio.text.toLowerCase())[0]
    } else {
      setTimeout(() => {
        self.openSuenioPopup = true
      }, 5000)
    }

    if (self.auxPagadoHasta) {
      let fechaHasta = moment(self.auxPagadoHasta)
      let fechaInicio = moment(self.inicioVigencia, 'DD/MM/YYYY')
      let fechaFin = moment(self.finVigencia, 'DD/MM/YYYY')
      const mesFinPago = `01/${(fechaInicio.month() + 1).toString().padStart(2, '0')}/${fechaInicio.year() + parseInt(self.periodoDePago)}`
      let fechaFinPago = moment(mesFinPago, 'DD/MM/YYYY').endOf('month')

      self.fechaDescripcionHasta = self.fechaDescripcion(fechaInicio, fechaHasta)

      self.fechaDescripcionFaltan = self.fechaDescripcion(fechaHasta, self.producto === 'VIDAFREE' ? fechaFinPago : fechaFin)
    }
  },
  created () {
    this.auxPeriodos = this.periodos.filter(data => Number(data.anho) <= 5)
    this.auxPeriodos.unshift({ anho: '01', lock: false })
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    methodClosePopup () {
      this.openPopupAux = false
      this.$emit('closePopup')
    },

    mesesDiferencia (date1, date2) {
      /* let meses = 0
      meses = (date2.getFullYear() - date1.getFullYear()) * 12
      console.log((date2.getFullYear() - date1.getFullYear()), meses, date1.getMonth(), date2.getMonth())
      meses -= date1.getMonth()
      meses += date2.getMonth() + 1
      return meses <= 0 ? 0 : meses */
      const mStartDate = moment([ date1.getFullYear(), date1.getMonth(), date1.getDate() ])
      const mTermDate = moment([ date2.getFullYear(), date2.getMonth(), date2.getDate() ])
      return Math.round(mTermDate.diff(mStartDate, 'months', true))
    },
    fechaDescripcion (fecha1, fecha2) {
      let descripcion = ''

      let anio = fecha2.diff(fecha1, 'years')

      if (anio > 1) {
        descripcion = anio + ' años '
      } else if (anio === 1) {
        descripcion = anio + ' año '
      }

      let mesTotal = fecha2.diff(fecha1, 'months')
      let mes = mesTotal - (anio * 12)

      if (mes > 1) {
        descripcion = descripcion + mes + ' meses'
      } else if (mes === 1) {
        descripcion = descripcion + mes + ' mes'
      }

      return descripcion.trim()
    },
    methodMyDream (obj) {
      let self = this
      self.openSuenioPopup = false
      self.firstTime = false
      if (!obj) {
        return
      }
      self.meta = obj

      self.eventLog({
        'tipoDocumento': self.taggeo.tipoDocumento,
        'numeroDocumento': self.taggeo.numeroDocumento,
        'categoria': 'Información',
        'nombre': 'Elige Sueño',
        'datos': {
          'numeroPoliza': self.taggeo.numeroPoliza,
          'grupoProducto': self.taggeo.ramo,
          'producto': self.taggeo.nombreProducto,
          'suenio': self.meta,
          'dispositivo': 'mobile'
        }
      })
    }
  },
  components: {
    TarjetaDetalleMisMetas,
    CardMisSolicitudes3
  }

}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/mis-seguros/PopupHoyHasta5.vue